import React from 'react';
import axios from 'axios';

/* window 전역 변수에 sStorage 값을 설정 */
window.sStorage =
  window.sessionStorage ||
  (() => {
    // window.sStorage = (function() {
    let winObj = opener || window; //opener가 있으면 팝업창으로 열렸으므로 부모 창을 사용
    let data = JSON.parse(winObj.top.name || '{}');
    let fn = {
      length: Object.keys(data).length /* 요거 ie8 에서 안된다고 함 */,
      setItem: function (key, value) {
        data[key] = value + '';
        winObj.top.name = JSON.stringify(data);
        fn.length++;
      },
      getItem: function (key) {
        return data[key] || null;
      },
      key: function (idx) {
        return Object.keys(data)[idx] || null; //Object.keys() 는 IE9 이상을 지원하므로 IE8 이하 브라우저 환경에선 수정되어야함
      },
      removeItem: function (key) {
        delete data[key];
        winObj.top.name = JSON.stringify(data);
        fn.length--;
      },
      clear: function () {
        winObj.top.name = '{}';
        fn.length = 0;
      },
    };
    return fn;
  })();

/* 예외처리 */
export class UnexpectedApiResultError {
  constructor(resultCode) {
    this.resultCode = resultCode;
  }
}

export const APIRequest = (request, addParams = {}) => {
  return new Promise((resolve, reject) => {
    const session_id = sStorage.getItem('sessionId');
    let htmAlias = sStorage.getItem('htmAlias') || 'jan';
    if (request?.includes('getHtmAlias')) htmAlias = 'jan';

    // const apiBaseUrl = process.env.REACT_APP_LOCAL_API_URL || process.env.REACT_APP_API_URL;
    // let apiUrl = apiBaseUrl.replace('placeholder', htmAlias);

    // console.log('apiBaseUrl >>', apiBaseUrl);
    let apiUrl = `https://${htmAlias}-api.himgt.net`;
    // let apiUrl = 'https://jan-api.himgt.net';
    // apiUrl = 'http://localhost';

    axios({
      method: 'post',
      //url: 'http://developers-api.payday.co.kr' + request,
      url: apiUrl + request,
      // params: params,
      data: addParams,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `${session_id}`,
      },
    })
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        reject(error);
      });
  });
};

export const APIMultipartRequest = (request, addParams = {}, config = {}) => {
  return new Promise((resolve, reject) => {
    const session_id = sStorage.getItem('sessionId');
    let htmAlias = sStorage.getItem('htmAlias') || 'jan';
    if (request?.includes('getHtmAlias')) htmAlias = 'jan';

    console.log('session_id', session_id);

    // const apiBaseUrl = process.env.REACT_APP_LOCAL_API_URL || process.env.REACT_APP_API_URL;
    // let apiUrl = apiBaseUrl.replace('placeholder', htmAlias);

    let apiUrl = `https://${htmAlias}-api.himgt.net`;
    // apiUrl = 'http://localhost:8081';

    axios({
      method: 'post',
      //url: 'http://developers-api.payday.co.kr' + request,
      url: apiUrl + request,
      // params: params,
      data: addParams,
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'application/json',
        Authorization: `${session_id}`,
      },
      ...config,
    })
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        reject(error);
      });
  });
};

// Blob 데이터를 받기 위한 API 요청 (파일 다운로드용)
export const APIBlobRequest = (request, addParams = {}) => {
  return new Promise((resolve, reject) => {
    const session_id = sStorage.getItem('sessionId');
    let htmAlias = sStorage.getItem('htmAlias') || 'jan';
    if (request?.includes('getHtmAlias')) htmAlias = 'jan';

    let apiUrl = `https://${htmAlias}-api.himgt.net`;
    // apiUrl = 'http://localhost:8081';

    axios({
      method: 'post',
      url: apiUrl + request,
      data: addParams,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `${session_id}`,
      },
      responseType: 'blob', // blob 응답 받기
    })
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        reject(error);
      });
  });
};

//테스트용
export const APIRequest_test = (request, addParams) => {
  return new Promise((resolve, reject) => {
    const session_id = sStorage.getItem('session_id');

    ////console.log(params);
    axios({
      method: 'post',
      url: 'https://api.smartvoting.kr/' + request,
      //url: "http://localhost:8081/" + request,
      // params: params,
      data: addParams,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `${session_id}`,
      },
    })
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        reject(error);
      });
  });
};
